import { render, staticRenderFns } from "./ScreenIcon.vue?vue&type=template&id=710561a2&scoped=true"
import script from "./ScreenIcon.vue?vue&type=script&lang=js"
export * from "./ScreenIcon.vue?vue&type=script&lang=js"
import style0 from "./ScreenIcon.vue?vue&type=style&index=0&id=710561a2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710561a2",
  null
  
)

export default component.exports